import { useState, useLayoutEffect } from "react"
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service"
import { Table, Spin, Tabs } from "antd"
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service"

const money = (value) => new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(value || 0)

const ReportPurchaseBehavior = () => {
    const today = format(new Date(), "yyyy-MM-dd")
    const [startDate, setStartDate] = useState(format(startOfMonth(new Date()), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(today)
    const [store, setStore] = useState(0)
    const [tab, setTab] = useState("first")
    const [data, setData] = useState({
        summary: {},
        first: [],
        first_cards: [],
        addons: [],
        addon_visits: [],
        frequency: [],
    })
    const [loading, setLoading] = useState(false)
    const [userAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))

    const fetchData = async () => {
        setLoading(true)
        const res = await axiosService("api/reports/purchase-behavior", "POST", { store, startDate, endDate })
        if (res?.data?.code === 200) {
            const payload = res.data.data || {}
            setData({
                summary: payload.summary || {},
                first: (payload.first || []).map((item) => ({ ...item, key: item.id })),
                first_cards: (payload.first_cards || []).map((item, i) => ({ ...item, key: i })),
                addons: (payload.addons || []).map((item) => ({ ...item, key: item.id })),
                addon_visits: (payload.addon_visits || []).map((item) => ({ ...item, key: item.visit_no })),
                frequency: (payload.frequency || []).map((item) => ({ ...item, key: item.customer_id })),
            })
        } else {
            setData({ summary: {}, first: [], first_cards: [], addons: [], addon_visits: [], frequency: [] })
        }
        setLoading(false)
    }

    useLayoutEffect(() => {
        fetchData()
    }, [startDate, endDate, store])

    const firstColumns = [
        { title: "Khách hàng", dataIndex: "full_name", fixed: "left", width: 160, ellipsis: true },
        { title: "SĐT", dataIndex: "mobile", width: 120 },
        { title: "Cơ sở", dataIndex: "store_name", width: 160, ellipsis: true },
        { title: "Ngày mua", dataIndex: "order_at", width: 150, render: (v) => v ? format(new Date(v), "dd-MM-yyyy HH:mm") : "" },
        { title: "Thẻ đăng ký buổi đầu", dataIndex: "cards", width: 260, ellipsis: true },
        { title: "Doanh số thuần", dataIndex: "net_sales", align: "right", width: 140, render: money },
        { title: "Nguồn", dataIndex: "source", width: 100 },
    ]
    const firstCardColumns = [
        { title: "Thẻ dịch vụ", dataIndex: "card", width: 320, ellipsis: true },
        { title: "Số KH", dataIndex: "customers", align: "center", width: 100 },
        { title: "Doanh số thuần", dataIndex: "net_sales", align: "right", width: 160, render: money },
    ]
    const addonColumns = [
        { title: "Khách hàng", dataIndex: "full_name", fixed: "left", width: 160, ellipsis: true },
        { title: "SĐT", dataIndex: "mobile", width: 120 },
        { title: "Cơ sở", dataIndex: "store_name", width: 150, ellipsis: true },
        { title: "Buổi thứ", dataIndex: "visit_no", align: "center", width: 90, render: (v) => v || "-" },
        { title: "Ngày mua", dataIndex: "order_at", width: 150, render: (v) => v ? format(new Date(v), "dd-MM-yyyy HH:mm") : "" },
        { title: "Thẻ dịch vụ chi tiết", dataIndex: "cards", width: 240, ellipsis: true },
        { title: "Doanh số thuần", dataIndex: "net_sales", align: "right", width: 140, render: money },
        { title: "Nguồn mua", dataIndex: "source", width: 110 },
    ]
    const visitColumns = [
        { title: "Buổi thứ", dataIndex: "visit_no", align: "center", width: 100, render: (v) => v || "Không gắn booking" },
        { title: "Số đơn", dataIndex: "orders", align: "center", width: 100 },
        { title: "Online", dataIndex: "online", align: "center", width: 100 },
        { title: "Offline", dataIndex: "offline", align: "center", width: 100 },
        { title: "Doanh số thuần", dataIndex: "net_sales", align: "right", width: 160, render: money },
    ]
    const freqColumns = [
        { title: "Khách hàng", dataIndex: "full_name", fixed: "left", width: 160, ellipsis: true },
        { title: "SĐT", dataIndex: "mobile", width: 120 },
        { title: "Cơ sở", dataIndex: "store_name", width: 160, ellipsis: true },
        { title: "Số lần mua thêm", dataIndex: "addon_count", align: "center", width: 140 },
        { title: "Dịch vụ chi tiết", dataIndex: "cards", width: 320, ellipsis: true },
        { title: "Doanh số thuần", dataIndex: "net_sales", align: "right", width: 140, render: money },
    ]

    const metricsByTab = {
        first: [
            ["KH buổi đầu", data.summary.first_customers || 0],
            ["DS thuần buổi đầu", money(data.summary.first_net)],
        ],
        addon: [
            ["Đơn mua thêm", data.summary.addon_orders || 0],
            ["DS thuần mua thêm", money(data.summary.addon_net)],
        ],
        frequency: [
            ["KH có mua thêm", data.summary.addon_customers || 0],
            ["Tổng lần mua thêm", data.summary.addon_orders || 0],
            ["DS thuần mua thêm", money(data.summary.addon_net)],
        ],
    }

    return (
        <div className={`${styles.background} container-fluid report-page course-customer-report`}>
            <FilterReport
                startDate={startDate}
                endDate={endDate}
                handleRangeDate={(sDate, eDate) => {
                    setStartDate(sDate)
                    setEndDate(eDate)
                }}
                store={store}
                handleStore={setStore}
                title="Báo cáo Hành vi mua hàng"
                type="purchase-behavior"
                userAdmin={userAdmin}
            />
            <Tabs activeKey={tab} onChange={setTab}>
                <Tabs.TabPane tab="Buổi đầu đăng ký dịch vụ" key="first" />
                <Tabs.TabPane tab="Mua thêm ở buổi nào" key="addon" />
                <Tabs.TabPane tab="Số lần mua thêm trong kỳ" key="frequency" />
            </Tabs>
            <Spin spinning={loading}>
                <Row className="mb-3">
                    {(metricsByTab[tab] || []).map(([label, value], index) => (
                        <Col key={label} xs={6} md={4} lg={3} className="mb-2">
                            <div className={`course-kpi${index === 0 ? " is-primary" : ""}`}>
                                <div className="course-kpi-label">{label}</div>
                                <strong>{value}</strong>
                            </div>
                        </Col>
                    ))}
                </Row>
                {tab === "first" && (
                    <>
                        <div className="course-panel mb-3">
                            <div style={{ padding: "14px 16px 8px", fontSize: 16, fontWeight: 700 }}>Gom theo thẻ buổi đầu</div>
                            <Table columns={firstCardColumns} dataSource={data.first_cards} pagination={false} bordered scroll={{ x: 600 }} />
                        </div>
                        <div className="bg-white card-service-matrix">
                            <div style={{ padding: "14px 16px 8px", fontSize: 16, fontWeight: 700 }}>Chi tiết KH buổi đầu</div>
                            <div className="px-2 pb-2">
                                <Table columns={firstColumns} dataSource={data.first} size="small" bordered scroll={{ x: 1200, y: 480 }} pagination={{ pageSize: 20 }} />
                            </div>
                        </div>
                    </>
                )}
                {tab === "addon" && (
                    <>
                        <div className="course-panel mb-3">
                            <div style={{ padding: "14px 16px 8px", fontSize: 16, fontWeight: 700 }}>Gom theo buổi mua thêm</div>
                            <Table columns={visitColumns} dataSource={data.addon_visits} pagination={false} bordered scroll={{ x: 700 }} />
                        </div>
                        <div className="bg-white card-service-matrix">
                            <div style={{ padding: "14px 16px 8px", fontSize: 16, fontWeight: 700 }}>Chi tiết đơn mua thêm</div>
                            <div className="px-2 pb-2">
                                <Table columns={addonColumns} dataSource={data.addons} size="small" bordered scroll={{ x: 1400, y: 480 }} pagination={{ pageSize: 20 }} />
                            </div>
                        </div>
                    </>
                )}
                {tab === "frequency" && (
                    <div className="bg-white card-service-matrix">
                        <div style={{ padding: "14px 16px 8px", fontSize: 16, fontWeight: 700 }}>KH mua thêm bao nhiêu lần trong kỳ</div>
                        <div className="px-2 pb-2">
                            <Table columns={freqColumns} dataSource={data.frequency} size="small" bordered scroll={{ x: 1200, y: 560 }} pagination={{ pageSize: 20 }} />
                        </div>
                    </div>
                )}
            </Spin>
        </div>
    )
}

export default ReportPurchaseBehavior
